/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { Steps, Row, Col, Spin, Button, message } from "antd";
import React, { useState, useEffect } from "react";
import KycDetails from "./KycDetails";
import NewMiscellaneous from "./NewMiscellaneous";
import PersonalDetails from "./PersonalDetails";
import CpDetails from "./CpDetails";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import "./style.scss";
import API from "../../api";
import urls from "../../api/urls";
const { SEND_OTP, VERIFY_OTP } = urls;
import DefaultCompany from "../LeadGenerationCP/DefaultCompany";
import CompanyRateCard from "./CompanyRateCard";
import { customerOnboardingAPI } from "../../api/LeadApi";
import useCustomNavigate from "../../components/customNavigationHook";
import { capitaliseWithHyphen } from "../../utils";
import AggreementDetails from "../LeadGenerationCP/AggreementDetails";
import DocumentDetails from "../LeadGenerationCP/DocumentDetails";
import BrandingDetails from "../LeadGenerationCP/BrandingDetails";
import NewRateCard from "../LeadGenerationCP/NewRateCard";
const currentEnv = process.env.REACT_APP_ENV;
const {
  GET_COMPANY_MASTER_LIST_V1,
  GET_CP_CUSTOMER_KYC,
  GET_CP_COMPANY_KYC,
  GET_QA_COMPANY_LIST,
} = urls;

export const CompanyProfile = () => {
  const navigate = useCustomNavigate();
  const [current, setCurrent] = useState(0);
  const [kycData, setKycData] = useState(null);
  //const [getData, setGetData] = useState({ status: "approved" });

  const [sideStepHide, setSideStepHide] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyData, setCompanyData] = useState({ status: "pending" });
  const [customerId, setCustomerId] = useState(
    JSON.parse(localStorage.getItem("selectedCompany")) ||
      JSON.parse(localStorage.getItem("customerId"))
  );

  //console.log(customerId, "customerId");

  const isEnable = JSON.parse(localStorage.getItem("isEnableCP"));

  const userPremiseId = JSON.parse(localStorage.getItem("userinfo"))?.premiseId;
  const onChange = (value) => {
    if (!isEnable && currentEnv === "qa") {
      getCPDetails();
    }
    setCurrent(value);
  };

  useEffect(() => {
    if (currentEnv === "prod" || (currentEnv === "qa" && isEnable)) {
      getCompanyList();
    } else if (currentEnv === "qa" && !isEnable) {
      getCPDetails();
    }
  }, []);

  const getCPDetails = async () => {
    const response = await customerOnboardingAPI.getLeadById(
      JSON.parse(localStorage.getItem("customerId"))
    );
    if (response?.status) {
      let data = response?.response?.data;
      setCompanyData(data);
    } else {
      message.error("Network error");
    }
  };

  const getCompanyList = async () => {
    // const response = await customerOnboardingAPI.getCompanyByCP({
    //   companyId:
    //     JSON.parse(localStorage.getItem("selectedCompany"))?.key || null,
    // });
    // setCompanyData(
    //   { ...response?.response?.data?.data?.[0], status: "approved" } || null
    // );

    const response = await customerOnboardingAPI.getMasterById(
      JSON.parse(localStorage.getItem("selectedCompany"))?.key,
      GET_COMPANY_MASTER_LIST_V1
    );
    const data = response?.response?.data;
    setCompanyData({ ...data, status: "pending" } || null);

    // setParentCompanyData(
    //   response?.response?.data?.data?.map((item) => ({
    //     ...item,
    //     value: item?.companyId,
    //     label: item?.organizationName,
    //   }))
    // );
  };

  const [companies, setCompanies] = useState([]);
  const getSelectedCompany = JSON.parse(
    localStorage.getItem("selectedCompany")
  );

  useEffect(() => {
    let callAPI = async () => {
      let response = await API.Api(
        `${GET_QA_COMPANY_LIST}/on-boarding/company/v1?cpId=${userPremiseId}&isActive=${true}`
      ).getCustomToken();

      // SEVASETU_COMPANY_ID
      if (response?.status) {
        setLoading(false);
        const comp = response?.response?.data?.data;

        const result = comp?.map((item) => {
          const sevSetuCompanyId = item?.metadata?.find(
            (meta) => meta?.key === "SEVASETU_COMPANY_ID"
          )?.value;

          const prospayCustomerId = item?.metadata?.find(
            (meta) => meta?.key === "PROSPAY_CUSTOMER_ID"
          )?.value;
          const companyName = item?.metadata?.find(
            (meta) => meta?.key === "ALIAS_COMPANY_NAME"
          )?.value;

          const isKycCompleted = item?.kycDocuments?.some(
            (doc) => doc?.verified
          );

          const companyId = item?.customerData?.companyId;

          const checkRegularNGST = item?.metadata?.find(
            (meta) => meta?.key === "IS_REGULAR"
          )?.value;

          const checkGSTExemption = item?.kycDocuments?.find(
            (meta) => meta?.idType == "GST"
          )?.idNumber;

          return {
            companyName: companyName || "N/A",
            companyId: sevSetuCompanyId,

            prospayCustomerId: prospayCustomerId,
            customerId: item.customerId,
            newCompanyId: companyId,
            isKycCompleted: isKycCompleted,
            isRegularNGST: checkRegularNGST && checkGSTExemption?.length > 0,
          };
        });

        let tempKyc = result?.filter((item) => item?.isKycCompleted);
        let sameCompany = tempKyc?.filter(
          (item) => item?.customerId !== getSelectedCompany?.customerId
        );
        //console.log(sameCompany, "sameCompany");
        setCompanies(
          sameCompany?.map((item, id) => ({
            key: item?.companyId,
            value: item?.customerId,
            label: capitaliseWithHyphen(item?.companyName),
            isRegularNGST: item?.isRegularNGST,

            customerId: item?.customerId,
            newCompanyId: item?.newCompanyId,
            isKycCompleted: item?.isKycCompleted,
            prospayCustomerId: item?.prospayCustomerId,
            cashQuotationName:
              item?.quotations?.find(
                (rate) => rate?.rateCardType?.toUpperCase() === "CASH"
              )?.rateCardName || null,
          }))
        );
      } else {
        console.log("comp");
      }
    };
    //if (isEnable) {
    if (currentEnv === "prod" || (currentEnv === "qa" && isEnable)) {
      callAPI();
    }
    //}

    // setLocalStore();
  }, []);

  //console.log(companies, "companies");
  const handleStepsChange = () => {
    if (current === 6) {
      setCurrent(6);
    } else {
      setCurrent(current + 1);
    }
  };

  const goBackStep = () => {
    window.scrollTo(0, 0);
    if (current == 0) {
      setCurrent(0);
    } else {
      setCurrent(current - 1);
    }
  };

  // const getKYCDetails = async () => {
  //   let response = await API.Api(
  //     `${GET_KYC_DETAILS}`
  //   ).getWithUserNPremiseHeader();
  //   if (response?.status) {
  //     setKycData(response.response.data);
  //   } else {
  //     message.error(response?.response?.data?.message);
  //   }
  // };

  async function getCpCustomerKyc() {
    let response = await API.Api(
      GET_CP_COMPANY_KYC + `${customerId?.newCompanyId}`
    ).getWithPremiseHeader();

    if (response?.status) {
      const data = response?.response?.data;
      setKycData(data);
      setCompanyData({ ...data, status: "pending" } || null);
      // setKycData(response?.response?.data);
    } else {
      message.error(response?.response?.data?.message);
    }
  }

  useEffect(() => {
    if (customerId) {
      if (currentEnv === "prod") {
        if (current !== 2) {
          getCpCustomerKyc();
        }
      } else if (currentEnv === "qa" && isEnable) {
        if (current !== 2) {
          getCpCustomerKyc();
        }
      }
    }
  }, [customerId, current]);

  const items = [
    {
      title: "KYC Details",
      description: "Please verify your KYC details",
      content: (
        <KycDetails
          handleStepsChange={handleStepsChange}
          goBackStep={goBackStep}
          kycData={companyData}
          companies={companies}
        />
      ),
    },
    {
      title: "Company Details",
      description: "View company details",
      content: (
        <DefaultCompany
          handleStepsChange={handleStepsChange}
          getData={companyData}
          goBackStep={goBackStep}
          hideGst={true}
          hideAadhaar={true}
          hidePan={true}
          hideTan={true}
        />
      ),
    },
    // {
    //   title: "Rate Card Details",
    //   description: "View rate details",
    //   content: (
    //     <CompanyRateCard
    //       handleStepsChange={handleStepsChange}
    //       getData={companyData}
    //       goBackStep={goBackStep}
    //       inActiveCp={true}
    //       // userType={"COMPANY"}
    //       // companyId={}
    //     />
    //   ),
    // },
  ];

  // if (currentEnv === "prod" || (currentEnv === "qa" && isEnable)) {
  //   items.push({
  //     title: "Rate Card Details",
  //     description: "View rate details",
  //     content: (
  //       <CompanyRateCard
  //         handleStepsChange={handleStepsChange}
  //         getData={companyData}
  //         goBackStep={goBackStep}
  //         // userType={"COMPANY"}
  //         // companyId={}
  //       />
  //     ),
  //   });
  // }
  if (currentEnv === "qa" && !isEnable) {
    items.push(
      {
        title: "Rate Card Details",
        description: "View rate details",
        content: (
          // <CompanyRateCard
          //   handleStepsChange={handleStepsChange}
          //   getData={companyData}
          //   goBackStep={goBackStep}
          //   // userType={"COMPANY"}
          //   // companyId={}
          // />
          <NewRateCard
            handleStepsChange={handleStepsChange}
            getData={{ ...companyData, status: "approved" }}
            //cpPinCodeData={cpPinCode}
            goBackStep={goBackStep}
            userType={"CP"}
            disableEdit={true}
          />
        ),
      },
      {
        title: "Aggrement Details",
        description: "Provide aggrement details",
        content: (
          <AggreementDetails
            handleStepsChange={handleStepsChange}
            goBackStep={goBackStep}
            getData={companyData}
          />
        ),
      },

      {
        title: "Document Details",
        description: "Provide document details",
        content: (
          <DocumentDetails
            handleStepsChange={handleStepsChange}
            goBackStep={goBackStep}
            getData={companyData}
          />
        ),
      },

      {
        title: "Branding Details",
        description: "Provide branding details",
        content: (
          <BrandingDetails
            handleStepsChange={handleStepsChange}
            goBackStep={goBackStep}
            getData={companyData}
          />
        ),
      }
    );
  } else if (currentEnv === "prod") {
    items.push({
      title: "Rate Card Details",
      description: "View rate details",
      content: <CompanyRateCard companyId={companyData?.companyId} />,
    });
  }

  return (
    <div className="pl-2 pr-2 mb-2">
      <div className="master-main-container cp-details-main-container">
        <Spin
          spinning={loading}
          indicator={
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          }
        >
          <Row className={sideStepHide ? "" : "p-1"}>
            {!sideStepHide && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                className="global-steps-container"
              >
                <Steps
                  current={current}
                  direction="horizontal"
                  onChange={onChange}
                  items={items}
                />
              </Col>
            )}
            <Col span={24}>
              <div>{items[current]?.content}</div>
            </Col>
          </Row>
        </Spin>
      </div>
    </div>
  );
};

export default CompanyProfile;
